import * as types from './ContentManagementActionType';

export const getAllCommunicationsSuccess = (payload) => ({
  type: types.GET_ALL_COMMUNICATIONS_SUCCESS,
  payload,
});

export const getAllCommunicationsFailure = (error) => ({
  type: types.GET_ALL_COMMUNICATIONS_FAILURE,
  error,
});

export const enableDisableCommunicationsSuccess = (payload) => ({
  type: types.ENABLE_DISABLE_COMMUNICATIONS_SUCCESS,
  payload,
});

export const enableDisableCommunicationsFailure = (error) => ({
  type: types.ENABLE_DISABLE_COMMUNICATIONS_FAILURE,
  error,
});

export const getAllCommunicationsRequestAction = (payload) => ({
  type: types.GET_ALL_COMMUNICATIONS_REQUEST,
  payload,
});

export const getCommunicationsDocumentTypeForDropdownSuccess = (payload) => ({
  type: types.GET_COMMUNICATIONS_DOCUMENT_TYPE_DROPDOWN_SUCCESS,
  payload,
});

export const getCommunicationsDocumentTypeForDropdownFailure = (error) => ({
  type: types.GET_COMMUNICATIONS_DOCUMENT_TYPE_DROPDOWN_FAILURE,
  error,
});

export const getAllCommunicationsRequest = (payload) => ({
  type: types.GET_ALL_COMMUNICATIONS_REQUEST,
  payload,
});
export const enableDisableCommunicationsRequest = (payload) => ({
  type: types.ENABLE_DISABLE_COMMUNICATIONS_REQUEST,
  payload,
});
export const getCommunicationsDocumentTypeForDropdownRequest = (payload) => ({
  type: types.GET_COMMUNICATIONS_DOCUMENT_TYPE_DROPDOWN_REQUEST,
  payload,
});
